import { useEffect, useMemo, useState } from "react";
import { checkExamImages, collectExamImages } from "../utils/examImages";
import ExamLoader from "./ExamLoader";

export default function ExamImageGate({ exam, children }) {
  const assets = useMemo(() => collectExamImages(exam), [exam]);
  const [round, setRound] = useState(0);
  const [result, setResult] = useState(null);
  useEffect(() => {
    let active = true;
    setResult(null);
    checkExamImages(assets).then(failed => {
      if (active) setResult({ assets, round, failed });
    });
    return () => { active = false; };
  }, [assets, round]);
  const current = result?.assets === assets && result?.round === round;
  if (current && result.failed.length === 0) return children;
  const failed = current ? result.failed : [];
  if (!failed.length) return <ExamLoader />;
  return (
    <div style={{ minHeight: "100vh", display: "grid", placeItems: "center", padding: 24, boxSizing: "border-box" }}>
      <div role="alert" style={{ maxWidth: 560, padding: 28, border: "1px solid #ccc", borderRadius: 12, background: "#fff", color: "#222" }}>
        <h2>Some exam images could not load</h2>
          <p>The questions are not available yet. Images are missing for: <strong>{[...new Set(failed.flatMap(asset => asset.labels))].join(", ")}</strong>.</p>
          <p>Check your internet connection and select Retry images. If this continues, ask your teacher for help before starting.</p>
          <button type="button" onClick={() => setRound(value => value + 1)}>Retry images</button>
      </div>
    </div>
  );
}
